module.exports = __webpack_public_path__ + "media/images/bg-f5cef51d79ffd59d5274e891cdc63ff8.png";